import { Box, Modal, Typography } from '@mui/material'

import React from 'react'
import CloseIcon from '@mui/icons-material/Close'
import useStyles from './../Styles/useStyleModalUserAccess'

import 'react-datepicker/dist/react-datepicker.css'
import { useDispatch } from 'react-redux'

import {
  setErrorTextSnackBar,
  setRequestTextSnackBar,
  setSuccessTextSnackBar
} from '../../../../../redux/actions/app'
import { addMonths } from 'date-fns'
import { updateUserApplicationInstanceAccessEAuthz } from '../../../../../redux/actions/eAuthz'
import { useNavigate } from 'react-router'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  height: 200,
  bgcolor: 'white',
  p: 4,
  borderRadius: '8px',
  boxShadow: '0px 0px 4px rgba(36, 55, 143, 0.4)'
}

export const ModalDisabledUserAccess = ({
  open,
  handleCloseAccessModal,
  userInstance
}) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const requestFailure = (text) => {
    dispatch(setRequestTextSnackBar())
    dispatch(setErrorTextSnackBar(text))
  }

  const userAccess = async () => {
    if (userInstance) {
      const fechaInicial = new Date()
      const fechaResultado = addMonths(fechaInicial, 6)

      const data = {
        userAppAccessId: userInstance.userAppAccessId,
        accessStatusCode:
          userInstance.userAppAccessStatusCode === 'GRANTED'
            ? 'REVOKED'
            : 'GRANTED',
        startDate: new Date().toISOString(),
        finishDate: new Date(
          fechaResultado.getFullYear(),
          fechaResultado.getMonth() + 1,
          0
        ).toISOString()
      }
      const response = await dispatch(
        updateUserApplicationInstanceAccessEAuthz(data)
      )

      if (response) {
        dispatch(
          setSuccessTextSnackBar(
            `${
              userInstance.userAppAccessStatusCode === 'GRANTED'
                ? 'Deshabilitación'
                : 'Habilitación'
            } exitosa`
          )
        )
        setTimeout(() => {
          navigate(0)
        }, 3000)
      } else {
        requestFailure('Ocurrió un error. Intente refrescar la página')
      }
    } else {
      requestFailure('Ocurrió un error. Intente refrescar la página')
    }
  }

  return (
    <div>
      <Modal
        open={open}
        onClose={handleCloseAccessModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <CloseIcon
            sx={{
              fontSize: 'medium',
              ml: 50,
              color: '#263057',
              cursor: 'pointer'
            }}
            onClick={handleCloseAccessModal}
          />

          <Typography
            sx={{ fontFamily: 'Raleway', color: '#263057' }}
            id="modal-modal-title"
            variant="h6"
            component="h2"
          >
            {userInstance.userAppAccessStatusCode === 'GRANTED'
              ? 'Deshabilitar'
              : 'Habilitar'}{' '}
            acceso
          </Typography>
          <Typography
            id="modal-modal-description"
            className={classes.typography}
          >
            ¿Está seguro de que desea{' '}
            {userInstance.userAppAccessStatusCode === 'GRANTED'
              ? 'deshabilitar'
              : 'habilitar'}{' '}
            el acceso a <b>Mi Estudio</b> al usuario?
          </Typography>
          <Box className={classes.buttons}>
            <ButtonConfirm userAccess={userAccess} />
            <ButtonClose handleCloseAccessModal={handleCloseAccessModal} />
          </Box>
        </Box>
      </Modal>
    </div>
  )
}

function ButtonClose ({ handleCloseAccessModal }) {
  const classes = useStyles()
  return (
    <Box className={classes.closeButton}>
      <Typography
        onClick={() => {
          handleCloseAccessModal()
        }}
        className={classes.closeButtonColor}
      >
        Cerrar
      </Typography>
    </Box>
  )
}
function ButtonConfirm ({ userAccess }) {
  const classes = useStyles()
  return (
    <Box
      className={classes.confirmButton}
      sx={{
        '&:hover': {
          bgcolor: '#1BF57F'
        }
      }}
    >
      <Typography
        onClick={() => userAccess()}
        className={classes.confirmButtonTypography}
      >
        Confirmar
      </Typography>
    </Box>
  )
}
